import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { errorAlert } from "../../../../helpers/alerts";
import { createPDSSegmentService } from "services/admin/productService";
import { addPDSSegment } from "redux/slices/admin/productSlice";
import SegmentProductForm from "components/admin/SegmentProductForm";
import { setLoading } from "redux/slices/uiSlice";

const CreateSegmentPaymentServiceScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlerSubmit = async (result) => {
    dispatch(setLoading(true))
    createPDSSegmentService(result).then((response) => {
      dispatch(addPDSSegment(response));
      navigate(-1)
    }).catch(e => errorAlert(e))
      .finally(() => dispatch(setLoading(false)))
  };

  return (
    <SegmentProductForm
      title="Crear Segmento"
      goBack={() => navigate(-1)}
      submit={handlerSubmit}
    />
  );
};

export default CreateSegmentPaymentServiceScreen;
